<template>
  <div class="feature-vehicle-row">
    <div class="feature-links-slider flexslider-no-border flexslider carousel" v-if="carLength > 6">
      <ul class="slides" style="width: 2000%;">
        <input id="feature-links-slide-count" type="hidden" value="10">
        <li class="slider-content" v-for="sedan in images.sedans" :key="sedan.modelName">
          <h4>{{sedan.modelName}}</h4>
          <a href="#">
            <img class="img-responsive" draggable="false" :alt="sedan.modelName" :src="sedan.angleView">
          </a>
        </li>
        <li class="slider-content" v-for="suv in images.suvs" :key="suv.modelName">
          <h4>{{suv.modelName}}</h4>
          <a href="#">
            <img class="img-responsive" draggable="false" :alt="suv.modelName" :src="suv.angleView">
          </a>
        </li>
        <li class="slider-content" v-for="truck in images.trucks" :key="truck.modelName">
          <h4>{{truck.modelName}}</h4>
          <a href="#">
            <img class="img-responsive" draggable="false" :alt="truck.modelName" :src="truck.angleView">
          </a>
        </li>
      </ul>
    </div>
    <div v-else class="plain-row row">
      <div class="col" v-for="sedan in images.sedans" :key="sedan.modelName">
        <div class="slider-content">
          <h4>{{sedan.modelName}}</h4>
            <a href="#">
              <img class="img-responsive" draggable="false" :alt="sedan.modelName" :src="sedan.angleView">
            </a>
        </div>
      </div>
      <div class="col" v-for="suv in images.suvs" :key="suv.modelName">
        <div class="slider-content">
          <h4>{{suv.modelName}}</h4>
            <a href="#">
              <img class="img-responsive" draggable="false" :alt="suv.modelName" :src="suv.angleView">
            </a>
        </div>
      </div>
      <div class="col" v-for="truck in images.trucks" :key="truck.modelName">
        <div class="slider-content">
          <h4>{{truck.modelName}}</h4>
            <a href="#">
              <img class="img-responsive" draggable="false" :alt="truck.modelName" :src="truck.angleView">
            </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import "../../static/woocommerce-FlexSlider-690832b/jquery.flexslider.js";
import "../../static/woocommerce-FlexSlider-690832b/jquery.flexslider-min.js";
import "../../static/woocommerce-FlexSlider-690832b/flexslider.css";

export default {
  props: ['images'],
  data() {
    return {
      activeClass: 'active'
    };
  },
  computed: {
    carLength () {
      return this.images.sedans.length + this.images.suvs.length + this.images.trucks.length;
    }
  },
  mounted() {

      $('.feature-links-slider').flexslider({
        selector: ".slides > li",
        animation: "slide",
        direction: "horizontal",
        animationLoop: true,
        slideshow: false,
        startAt: 0,
        touch: true,
        minItems: 3,
        maxItems: 10,
        itemMargin: 10,
        itemWidth: 230,
        slideshowSpeed: 6000
      });
    }
  }
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>
<style scoped src="../../static/woocommerce-FlexSlider-690832b/flexslider.css"></style>

<style lang="less" scoped src="../../static/woocommerce-FlexSlider-690832b/flexslider.less"></style>

<style scoped>
  .feature-vehicle-row {
    background: #fff;
    padding: 25px 0;
  }
  .feature-links-slider {
    background: #fff;
    position: relative;
    margin: 20px 0px !important;
    overflow: hidden;
  }
  .feature-vehicle-row .slider-content h4 {
    color: var(--primary-dark);
    font-size: 15px;
    font-weight: 300;
    font-family: helvetica;
    text-align: center;
  }
  .feature-links-slider .flex-direction-nav a:before {
    text-shadow: 1px 1px 8px rgba(255,255,255,.9);
  }
  .feature-links-slider ul.slides {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .feature-vehicle-row .plain-row {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .feature-vehicle-row .plain-row img, .feature-vehicle-row .flexslider img {
    max-height: 125px;
    width: auto;
    margin: auto;
  }
</style>
